module.exports = "/static/assets/84e7bba015155cafe943e83d54c0c4de.png";